import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useVariantJumpingHomePageCheckExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.VariantJumpingHomePageCheck,
        AmplitudeVariants.VariantJumpingHomePageCheck.Treatment
    );
